Ext.define('SA.VectorMapEditController', {
    constructor({model, activeState}) {
        this.model = model;
        this.activeState = activeState;

        this.modelLocations = new SA.EditModelLocations(model);
        this.modelAttributes = new SA.EditModelAttributes(model);

        this.locationsPanel = SA.EditPanelBuilder.forLocations().withRadios('Select a location').build();
        this.attributesPanel = SA.EditPanelBuilder.forAttributes().withRadios('Select a data variable').build();
        this.businessesPanel = SA.EditPanelBuilder.forBusinesses().withRadios('Select a business').build();

        this.view = Ext.widget({
            xtype: 'edit-view',
            enableDoneButton: true,
            panels: [this.locationsPanel, this.attributesPanel, this.businessesPanel].map(panel => panel.getView())
        });

        this.projectView = SA.ProjectView.createHidden(this.view);

        this.initEvents();
    },

    initEvents() {
        this.model.on('remove', () => this.projectView.destroy());

        this.modelObserver = SA.EditModelObserver.create(this.model, this.refresh, this);
        this.modelObserver.observeName();
        this.modelObserver.observeLocations();
        this.modelObserver.observeAttributes();
        this.modelObserver.observeBusinesses();

        this.activeState.onActive(this.onActive, this);
        this.activeState.onChange(active => this.modelObserver.setEnabled(active));

        this.sidebarObserver = new SA.SidebarObserver(this.activeState);
        this.sidebarObserver.onUseLocation(this.onSidebarUseLocation, this);
        this.sidebarObserver.onUseAttribute(this.onSidebarUseAttribute, this);
        this.sidebarObserver.onUseBusiness(this.onSidebarUseBusiness, this);

        this.view.onDoneClick(() => SA.AppController.showProjectView(this.model));

        this.locationsPanel.onItemChange(this.onLocationsPanelItemChange, this);
        this.attributesPanel.onItemChange(this.onAttributesPanelItemChange, this);
        this.businessesPanel.onItemChange(this.onBusinessesPanelItemChange, this);
    },

    onActive() {
        SA.ProjectViewToolbar.clearToolbar();
        SA.ProjectView.show(this.projectView);

        this.refresh();
    },

    onAttributesPanelItemChange(radio) {
         this.model.addAttribute(radio.getDataId());
         this.model.save();
    },

    onBusinessesPanelItemChange(radio) {
        this.model.setBusinessSearch(radio.getDataId());
        this.model.save();
    },

    onLocationsPanelItemChange(radio) {
         this.model.setLocation(radio.getDataId());
         this.model.save();
    },

    onSidebarUseAttribute(id) {
        this.view.scrollToEl(() => this.attributesPanel.getEnabledItemEl(id));
    },

    onSidebarUseBusiness(id) {
        this.view.scrollToEl(() => this.businessesPanel.getEnabledItemEl(id));
    },

    onSidebarUseLocation(id) {
        this.view.scrollToEl(() => this.locationsPanel.getEnabledItemEl(id));
    },

    refresh() {
        this.view.setViewName(this.model.getName());

        this.locationsPanel
            .setEnabledIds([null, ...this.modelLocations.getSupported()])
            .setDisabledIds(this.modelLocations.getUnsupported())
            .eachItem(radio => radio.refreshLabel())
            .eachEnabledItem(radio => radio.setCheckedSuppressed(this.modelLocations.isSelected(radio.getDataId())));

        this.attributesPanel
            .setEnabledIds([null, ...this.modelAttributes.getSupported()])
            .setDisabledIds(this.modelAttributes.getUnsupported())
            .eachEnabledItem(radio => radio.setCheckedSuppressed(this.modelAttributes.isSelected(radio.getDataId())));

        this.businessesPanel
            .setEnabledIds([null, ...this.model.getProject().getBusinessSearches()])
            .eachEnabledItem(radio => radio.setCheckedSuppressed(radio.getDataId() === this.model.getBusinessSearch()));
    }
});